import {} from "../mod/index.js";
import { addNode } from "../net/addNode.js";
import { findNodeEntryOrFail } from "../net/findNodeEntryOrFail.js";
import { findOutputPorts } from "../net/findOutputPorts.js";
import {} from "../net/index.js";
import {} from "../port/index.js";
import {} from "../value/index.js";
export function capType(mod, net, t) {
    const parameter = {
        name: "covering",
        t,
        isPrincipal: false,
    };
    const node = addNode(net, mod, "@typeCap", [], [parameter]);
    const nodeEntry = findNodeEntryOrFail(net, node);
    nodeEntry.asTypeCap = {};
    return findOutputPorts(net, node)[0];
}
//# sourceMappingURL=capType.js.map